import { render, staticRenderFns } from "./AiResponse.vue?vue&type=template&id=033daa5f&scoped=true"
import script from "./AiResponse.vue?vue&type=script&lang=js"
export * from "./AiResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033daa5f",
  null
  
)

export default component.exports